import * as actions from '../customize/actions';

export const toggleRdpModal = (pairing) => {
  return {
    type: actions.TOGGLE_RDP_MODAL,
    pairing: pairing,
  };
};
